//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux';

//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selector = (state) => state.activities;
const ownGraphicOrganizerSelector = (state) => state.ownGraphicOrganizers;
const shareListSelector = (state) => state.shareList;

export const useActivities = () =>{
    const selectedData = useSelector(selector, shallowEqual)
    return selectedData;
}

export const useOwnGraphicOrganizers = () => {
    const selectedData = useSelector(ownGraphicOrganizerSelector, shallowEqual)
    return selectedData;
}

export const useShareList = () => {
    const selectedData = useSelector(shareListSelector, shallowEqual)
    return selectedData;
}